import Vue from 'vue';

class AccessibilityStore {
    constructor() {
        this.storeVM = new Vue({
            data: {
                isEnabled: false,
            },
        });
        this.ready = false;
    }

    get isEnabled() {
        return this.storeVM.$data.isEnabled;
    }

    setup() {
        if (!this.ready && window.special) {
            window.special.OnOff(() => {
                this.storeVM.$data.isEnabled = false;
            });
            this.ready = true;
        }
        return this;
    }

    toggle() {
        if (window.special) {
            this.storeVM.$data.isEnabled = window.special.Toggle();
        }
    }
}

export default {
    Store: AccessibilityStore,
    install(Vue, options) {
        Vue.mixin({
            beforeCreate() {
                this.$accessibility = options.store;
            },
        });
    },
};


